'use client'
import { SelectionDictionaryParams } from '../services'
import useGet from './use-get'
import { Dictionary, dictionaryMappers } from '../../lib'

const useQueryHook = ({
  selectDictionary,
  search,
  searchFieldName = 'code',
}: {
  search: string
  searchFieldName?: keyof Dictionary
  selectDictionary: SelectionDictionaryParams
}) => {
  const query = useGet.useQueryHook(selectDictionary)

  return {
    ...query,
    data: query.data.find((item) => item[searchFieldName] == search) || dictionaryMappers.mapDictionary({}),
  }
}

const hook = {
  useQueryHook,
}

export default hook
